import i18n                                    from '@/lang/index.js';
import Service                                 from '@/api/service';
import ky                                      from 'ky';
import { getKeyValueProfile, getKeyValueTrad } from '@/composables/formatData';

export const INVOICE_STATUS_TO_BE_PAID = 'to_be_paid';
export const INVOICE_STATUS_PAID = 'paid';
export const INVOICE_STATUS_REFUSED = 'refused';
export const INVOICE_STATUS_CANCELLED = 'cancelled';

export function useInvoiceStatusList() {

  const messages = i18n.global.messages[i18n.global.locale];
  return [
    { key : INVOICE_STATUS_TO_BE_PAID, value : messages.invoice.status.to_be_paid, color : 'orange' },
    { key : INVOICE_STATUS_PAID, value : messages.invoice.status.paid, color : 'green' },
    { key : INVOICE_STATUS_REFUSED, value : messages.invoice.status.refused, color : 'red' },
    { key : INVOICE_STATUS_CANCELLED, value : messages.invoice.status.cancelled, color : 'red' }
  ];
}

export async function useFormatInvoice(tenantId, invoice) {

  return {
    ...invoice,
    status      : useInvoiceStatusList().find(status => status.key === invoice.status),
    issuer      : await getKeyValueProfile(tenantId, invoice.issuer),
    paymentNote : invoice.paymentNote ? useFormatInvoicePaymentNote(invoice.paymentNote) : null,
    uploadedBy  : await getKeyValueProfile(tenantId, invoice.uploadedBy)
  };
}

export async function getInvoiceBase64Data(invoiceId, tenantId) {

  try {
    const invoice = await Service.getInvoice(tenantId, invoiceId);

    if (invoice?.documentId) {
      const url = await Service.getDocumentFromS3(tenantId, invoice.documentId);
      const response = await ky.get(url.url);

      if (!response.body) {
        return undefined;
      }

      return window.URL.createObjectURL(await response.blob());
    }

    return undefined;

  } catch {
    return undefined;
  }
}

export const PAYMENT_METHOD_CHEQUE = 'cheque';
export const PAYMENT_METHOD_TRANSFER = 'transfer';

export function useInvoicePaymentMethodsList() {

  const messages = i18n.global.messages[i18n.global.locale];
  return [
    { key : PAYMENT_METHOD_CHEQUE, value : messages.paymentMethods.cheque },
    { key : PAYMENT_METHOD_TRANSFER, value : messages.paymentMethods.transfer }
  ];
}

export function useFormatInvoicePaymentNote(paymentNote) {

  return {
    date   : paymentNote.date,
    infos  : paymentNote.infos,
    method : getKeyValueTrad('paymentMethods', paymentNote.method)
  };
}

export function useUnformatInvoicePaymentNote(paymentNote) {

  return {
    date   : paymentNote.date,
    infos  : paymentNote.infos,
    method : paymentNote.method.key
  };
}
